module.exports = __webpack_public_path__ + "static/media/gage-bio.f5c734e0.jpg";